import _ from 'lodash';
import domains from '../containers/Domains';
import contextMakePost from './Context';
import { getLocalStorageDataOrFetch } from './fbCallManager';

const endpoint = domains.fbEndpoint;

export const createImage = async (data, token) => {
  const parameters = {
    access_token: token,
    published: false,
    url: data.url
  };

  const id = data.id;
  const result = await contextMakePost(parameters, id);
  return result.json();
};

export const createCanvasPhoto = async (data, token) => {
  const parameters = {
    access_token: token,
    canvas_photo: data.canvas_photo
  };

  const id = data.id;
  const result = await contextMakePost(parameters, id);
  return result.json();
};

export const createCanvasCarousel = async (data, token) => {
  const parameters = {
    access_token: token,
    canvas_carousel: data.canvas_carousel
  };

  const id = data.id;
  const result = await contextMakePost(parameters, id);
  return result.json();
};

export const getCanvasPhoto = async (id, token) => {
  const parameters = {
    access_token: token,
    id,
    fields: 'id,name,action'
  };

  const query = _.template(
    `${endpoint}<%= id%>?&fields=<%= fields%>&access_token=<%= access_token%>`
  );

  const jsonResult = await getLocalStorageDataOrFetch(query(parameters));

  return jsonResult;
};

export const getFbThumbnailByAssetId = async (assetId, accessToken) => {
  // to do: skipCache flag to getLocalStorageDataOrFetch

  const parameters = {
    access_token: accessToken,
    id: assetId,
    fields: 'thumbnails'
  };

  const query = _.template(
    `${endpoint}<%= id%>?&fields=<%= fields%>&access_token=<%= access_token%>`
  );

  const jsonResult = await getLocalStorageDataOrFetch(query(parameters));

  return jsonResult;
};



// WEBPACK FOOTER //
// ./src/fbApi/Image.js